import { render, staticRenderFns } from "./app-bundle-learn-more-dialog.vue?vue&type=template&id=487fdd7e&scoped=true"
import script from "./app-bundle-learn-more-dialog.vue?vue&type=script&lang=js"
export * from "./app-bundle-learn-more-dialog.vue?vue&type=script&lang=js"
import style0 from "./app-bundle-learn-more-dialog.vue?vue&type=style&index=0&id=487fdd7e&prod&lang=scss&scoped=true"
import style1 from "./app-bundle-learn-more-dialog.vue?vue&type=style&index=1&id=487fdd7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487fdd7e",
  null
  
)

export default component.exports